import React from 'react';

interface IMinMaxDimensions {
    min: number;
    max: number;
    unit: 'angle' | 'inch';
}

const MinAndMaxDimensions = (props: IMinMaxDimensions) => {
    return props?.unit === 'inch' ? (
        <div className="d-flex flex-row w-100 justify-content-between">
            <div className="font-size-sm">Min: {props.min.toFixed(3)}"</div>
            <div className="font-size-sm">Max: {props.max.toFixed(3)}"</div>
        </div>
    ) : props.unit === 'angle' ? (
        <div className="d-flex flex-row w-100 justify-content-between">
            <div className="font-size-sm">Min: {props.min.toFixed(0)}°</div>
            <div className="font-size-sm">Max: {props.max.toFixed(0)}°</div>
        </div>
    ) : null;
};
export default MinAndMaxDimensions;
